<template>
  <div class="right_show_container">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.right_show_container {
  width: 80%;
  background-color: #fff;
  border-radius: 4px;
}
</style>